export default "__VITE_ASSET__Dhrz5HKL__"